import type {
	OriginalItemTypes,
	RenderableItemTypes,
} from "@memorang/types/src/session/new-session";
import { helpDialog } from "./dialog-configs";

const variatTitleMap = {
	MCQ: "Multiple-Choice Question",
	SATA: "Multiple-Response Question",
	CST: "CST",
	writing: "Writing Prompt",
	listening: "Listening Prompt",
	speaking: "Speaking Prompt",
	readingprose: "Reading Prose",
	readingdocuments: "Reading Chart",
	hotspot: "Hotspots",
	quantitative: "Quantitative",
	emailwriting: "email",
	essayGrading: "Essay Grading",
	audioResponse: "Audio Response",
	sequence: "Sequence",
	textAnswer: "Text Answer",
	audioAnswer: "Audio Answer",
	markingAnswer: "Marking Answer",
	vocabulary: "Vocabulary",
	reading: "Reading",
	WRITING: "Writing",
};

export const sessionMaxWidth = {
	summative: 960,
	formative: 768,
};

const AI_SUBMITTABLE_VARIANTS = [
	"INTEGRATED_WRITING_RESPONSE",
	"ACADEMIC_DISCUSSION_RESPONSE",
	"AUDIO_INPUT",
	"WRITING_INPUT",
	"WRITING_EMAIL",
	"LONG_TURN",
	"STORY_TELLING",
];

export const MAPPED_ITEM_TYPES: Record<OriginalItemTypes, RenderableItemTypes> =
	{
		MCSS: "MCQ",
		MCQ: "MCQ",
		NOTICE_MCQ: "MCQ",
		LEXICAL_CLOZE: "MCQ",
		PASSAGE_QUESTION: "MCQ",
		MCSSH: "MCQ",
		MCMS: "SATA",
		MCMSH: "SATA",
		INSERT_TEXT: "INSERT_TEXT",
		MATCH_MS: "SATA",
		MCSSM: "MCQ",
		MCMSM: "SATA",
		MCGS: "SATA",
		MCOS: "SEQUENCE",
		NOTE_COMPLETION: "NOTE_COMPLETION",
		AUDIO_INPUT: "AUDIO_INPUT",
		STORY_TELLING: "AUDIO_INPUT",
		LONG_TURN: "AUDIO_INPUT",
		ACADEMIC_DISCUSSION_RESPONSE: "WRITING_INPUT",
		INTEGRATED_WRITING_RESPONSE: "WRITING_INPUT",
		WRITING_EMAIL: "WRITING_INPUT",
		LISTENING_REPLAY: "MCQ",
	};

const stimulusIconMap = {
	READING: "book-open-page-variant-outline" as const,
	WRITING: "file-document-edit-outline" as const,
	LISTENING: "ear-hearing" as const,
	SPEAKING: "microphone-outline" as const,
	IMAGE: "image-outline" as const,
};

// Render above the bottom app bar + some padding
export const FAB_BOTTOM_POSITION = 80 + 24;

export { variatTitleMap, helpDialog, AI_SUBMITTABLE_VARIANTS, stimulusIconMap };
